import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Header2 from '../components/Header2';
import Footer from '../components/Footer';
import { motion, AnimatePresence } from 'framer-motion';
import LogoContainer from '../components/LogoContainer';
import Up from '../components/Up';
import PolitikaPopupComponent from '../components/PolitikaPopupComponent';

const PageContainer = () => {
    const location = useLocation();
    const [toggle, setToggle] = useState(false);
    const [isScrolling, setIsScrolling] = useState(false);

    useEffect(() => {
        // Scroll to top whenever the location changes
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        let scrollTimeout;

        const handleScroll = () => {

            setIsScrolling(true);


            clearTimeout(scrollTimeout);


            scrollTimeout = setTimeout(() => {
                setIsScrolling(false);
            }, 10);
        };


        window.addEventListener('scroll', handleScroll);


        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearTimeout(scrollTimeout);
        };
    }, []);

    const pageVariants = {
        initial: {
            translateY: -30,
            scale: 0.95,
            opacity: 0,
        },
        in: {
            translateY: 0,
            scale: 1,
            opacity: 1,
            transition: {
                duration: 0.8,
                ease: [0.25, 0.1, 0.25, 1],
            },
        },
        out: {
            translateY: 30,
            scale: 1,
            opacity: 0,
            transition: {
                duration: 0.6,
                ease: [0.25, 0.1, 0.25, 1],
            },
        },
    };

    const pageTransition = {
        type: 'spring',
        stiffness: 100,
        damping: 25,
        mass: 0.8,
        duration: 1.5,
        ease: [0.25, 0.1, 0.25, 1],
    };

    const isHomePage = location.pathname === '/';

    return (
        <motion.div animate={{
            // backgroundColor: isScrolling ?  '#000': '#fff', 
        }}
            transition={{
                duration: 5,
                ease: [0.25, 0.1, 0.25, 1],
            }} className='flex flex-col md:flex-row-reverse relative  '>
            <Header toggle={toggle} setToggle={setToggle} />


            <motion.div
                className='w-full md:w-[calc(100vw-7rem)] flex-none bg-white relative '
                animate={{
                    scale: isScrolling ? 0.95 : 1, // Only scale when actively scrolling
                }}
                transition={{
                    duration: 0.6,
                    ease: [0.25, 0.1, 0.25, 1],
                }}
            >
                <LogoContainer />
                <motion.div
                    key={location.pathname}
                    initial='initial'
                    animate='in'
                    exit='out'
                    variants={pageVariants}
                    transition={pageTransition}
                    className={`min-h-screen relative z-10 bg-white ${isHomePage ? 'p-0' : 'pt-48'}`}
                >
                    <Outlet />
                    <Up />
                    <Footer />
                </motion.div>
            </motion.div>


            <Header2 toggle={toggle} setToggle={setToggle} />


{/* <PolitikaPopupComponent/> */}



        </motion.div>
    );
}

export default PageContainer;
